import React, { useState } from 'react';
import styled from '@emotion/styled';
import { gutterSizes } from '@gumtree/ui-library/src/base/theme';
import { trackGA4Event } from '@gumtree/shared/src/util/ga4-shared';

import Dropdown from './dropdown';
import PrizeDropdown from './price';

export interface FilterData {
    name: string;
    label: string;
    type?: 'multi-select' | 'select' | 'price';
    renderOptions?: () => React.ReactNode;
    options?: {
        label: string;
        value: string | number;
    }[];
}
export interface MultiSelectGroupProps {
    className?: string;
    onClear?: (filter: FilterData) => void;
    filters: FilterData[];
    value: {
        [key: string]: any;
    };
    onChange?: (
        value: { [key: string]: string | number | (string | number)[] },
        changed: { key: string; value: any }
    ) => void;
}

export interface FilterItemProps {
    value: any;
    onChange: (value: any) => void;
    label?: string;
    placeholder?: string;
    onMenuVisibleChange?: (visible?: boolean) => void;
}

const MultiSelectGroupContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 0 ${gutterSizes.base};
    flex-wrap: wrap;
`;

const MultiSelectGroup: React.FC<MultiSelectGroupProps> = (props) => {
    const { value, filters = [], onChange, onClear } = props;
    const [selfValue, setSelfValue] = useState(value);
    // useEffect(() => {
    //     if (JSON.stringify(selfValue) !== JSON.stringify(value)) {
    //         setSelfValue(value);
    //     }
    // }, [value]);
    function onValueChang(value, key: string) {
        setSelfValue((preValue) => {
            const mergedValue = {
                ...preValue,
                [key]: value,
            };
            onChange?.(mergedValue, { key, value });
            return mergedValue;
        });
    }

    const renderDropdown = (filter) => {
        const onMenuVisibleChange = (visible?: boolean) => {
            visible &&
                trackGA4Event<GA4.SearchFilterEvent>({
                    event: 'expand_search_filter',
                    filterName: filter.name,
                });
        };

        if (filter.options?.length === 0) return null;

        if (filter.type === 'price')
            return (
                <PrizeDropdown
                    key={filter.name}
                    value={selfValue[filter.name]}
                    placeholder={filter.label}
                    onChange={(value) => onValueChang(value, filter.name)}
                    onMenuVisibleChange={onMenuVisibleChange}
                />
            );

        return (
            <Dropdown
                key={filter.name}
                type={filter.type}
                options={filter.options}
                renderOptions={filter.renderOptions}
                placeholder={filter.label}
                value={selfValue[filter.name]}
                onChange={(value) => onValueChang(value, filter.name)}
                onMenuVisibleChange={onMenuVisibleChange}
                onClear={() => {
                    onClear && onClear(filter);
                }}
            />
        );
    };

    return (
        <MultiSelectGroupContainer data-testid="multi-select-group" className={props.className}>
            {filters.map(renderDropdown)}
        </MultiSelectGroupContainer>
    );
};

export default MultiSelectGroup;
